/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Initiative } from '../../models/initiative';

export interface GetInitiative$Params {
  id: string;
}

export function getInitiative(http: HttpClient, rootUrl: string, params: GetInitiative$Params, context?: HttpContext): Observable<StrictHttpResponse<Initiative>> {
  const rb = new RequestBuilder(rootUrl, getInitiative.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Initiative>;
    })
  );
}

getInitiative.PATH = '/initiative/{id}';
